/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import n from"../../RasterFunction.js";function e(e,t,o){return Object.keys(t).forEach((n=>{null==t[n]&&delete t[n]})),o||(o="unknown"),new n({functionName:e,functionArguments:t,outputPixelType:o})}export{e as createRasterFunction};
